@if (hasEntitlements) {
  <div class='reports-list-container'>
    <div class='filter-container'>
      <form [formGroup]="reportFilter">
        <mat-form-field appearance="outline">
          <mat-label>Filter by Title or Request ID</mat-label>
          <input matInput formControlName="reportFilterValue" (keyup)="applyFilter($event.target.value)"
            placeholder="Title or Request ID" />
            <span class="material-symbols-outlined filter-icon" matSuffix>search</span>
          </mat-form-field>
        </form>
      </div>
      <table [dataSource]="reportsToDisplay" mat-table matSort matSortActive="publishDate" matSortDirection="asc" matSortDisableClear>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;</th>
          <td mat-cell *matCellDef="let element">
            @if (element.publishDate && !element.isDownloadPending) {
              <span class="material-symbols-outlined" (click)="downloadReport(element)">
              get_app</span>
            }
            @if (element.isDownloadPending) {
              <mat-spinner [diameter]="25"></mat-spinner>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell mat-sort-header *matHeaderCellDef sortActionDescription="Sort by type"> Title </th>
          <td mat-cell *matCellDef="let element"> {{element.reportTitle}} </td>
        </ng-container>
        <ng-container matColumnDef="format">
          <th mat-header-cell mat-sort-header *matHeaderCellDef sortActionDescription="Sort by format"> Format </th>
          <td mat-cell *matCellDef="let element"> {{element.format}} </td>
        </ng-container>
        <ng-container matColumnDef="publishDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef sortActionDescription="Sort by publishDate"> Published
          </th>
          <td mat-cell *matCellDef="let element"> {{element.publishDate ? (element.publishDate | date: 'MM/dd/yyyy') :
          element.executionStatus}} </td>
        </ng-container>
        <ng-container matColumnDef="reportId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef sortActionDescription="Sort by reportId"> Request ID
          </th>
          <td mat-cell *matCellDef="let element"> {{element.reportId}} </td>
        </ng-container>
      </table>
      <mat-paginator #paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
      </mat-paginator>
    </div>
  } @else {
    <div class="loading-container warning-message">
      {{ noEntitlementsMessage || 'Your currently selected agency does not have access to view Agency Reports. Try a
      different agency if available.'}}
    </div>
  }

